import { Flex, SegmentedControl, Text, Tooltip } from "@radix-ui/themes";
import Image from "next/image";
import { useState } from "react";

export const Skills = () => {
  const [value, setValue] = useState<Skill["type"]>("all");

  return (
    <Flex
      direction={"column"}
      justify={"start"}
      align={"center"}
      gap={"6"}
      className={"mt-32 w-full md:max-w-80"}
    >
      <Flex direction={"column"} justify={"start"} align={"center"} gap={"1"}>
        <Text
          size={"3"}
          weight={"medium"}
          style={{
            color: "var(--tomato-9)",
            fontWeight: "600",
          }}
        >
          기술 스택 및 도구
        </Text>
        <Text
          size={"6"}
          style={{
            fontWeight: "600",
            lineHeight: 1.3,
          }}
          align={"center"}
        >
          문제 해결 과정에서 선택하고
          <br />
          사용해온 기술과 도구입니다.
        </Text>
      </Flex>
      <SegmentedControl.Root
        className={"skill-group"}
        style={{
          boxShadow: "var(--shadow-3)",
        }}
        size={"2"}
        value={value}
        onValueChange={(v) => setValue(v as Skill["type"])}
      >
        <SegmentedControl.Item
          value="front"
          onClick={(e) => {
            e.preventDefault();
            setValue((v) => {
              return v === "front" ? "all" : "front";
            });
          }}
          className={"skill-group-item"}
        >
          프론트엔드
        </SegmentedControl.Item>
        <SegmentedControl.Item
          value="back"
          onClick={(e) => {
            e.preventDefault();
            setValue((v) => {
              return v === "back" ? "all" : "back";
            });
          }}
          className={"skill-group-item"}
        >
          백엔드
        </SegmentedControl.Item>
        <SegmentedControl.Item
          value="infra"
          onClick={(e) => {
            e.preventDefault();
            setValue((v) => {
              return v === "infra" ? "all" : "infra";
            });
          }}
          className={"skill-group-item"}
        >
          환경 · 배포
        </SegmentedControl.Item>
        <SegmentedControl.Item
          value="design"
          onClick={(e) => {
            e.preventDefault();
            setValue((v) => {
              return v === "design" ? "all" : "design";
            });
          }}
          className={"skill-group-item"}
        >
          디자인 · 협업
        </SegmentedControl.Item>
      </SegmentedControl.Root>
      <Flex justify={"center"} wrap={"wrap"} gap={"4"} className={"pt-1.5"}>
        {skills.map((item) => (
          <SkillItem
            key={item.name}
            {...item}
            blur={value !== "all" && value !== item.type}
          />
        ))}
      </Flex>
    </Flex>
  );
};

type Skill = {
  type: "front" | "back" | "infra" | "design" | "all";
  name: string;
};

const skills: Skill[] = [
  // front
  { type: "front", name: "JavaScript" },
  { type: "front", name: "React" },
  { type: "front", name: "Next.js" },
  { type: "front", name: "TypeScript" },
  { type: "front", name: "Three.js" },
  { type: "front", name: "Zustand" },
  // back
  { type: "back", name: "Java" },
  { type: "back", name: "Spring Boot" },
  { type: "back", name: "MySQL" },
  { type: "back", name: "Redis" },
  // infra
  { type: "infra", name: "AWS" },
  { type: "infra", name: "GitLab CI" },
  // design
  { type: "design", name: "Figma" },
  { type: "design", name: "Jira" },
  { type: "design", name: "Slack" },
];

const SkillItem = ({ type, name, blur }: Skill & { blur?: boolean }) => {
  return (
    <Tooltip content={name}>
      <Image
        src={`/images/skills/${type}/${name}.png`}
        alt={name}
        width={0}
        height={0}
        sizes={"100vw"}
        quality={75}
        className={`w-12 h-12 md:w-16 md:h-16 object-cover drop-shadow-md ${blur ? "opacity-15 blur-md" : ""} transition-all`}
        style={{
          pointerEvents: blur ? "none" : "auto",
        }}
      />
    </Tooltip>
  );
};
